import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

import { SiteIconService } from '../../services/site-icon.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { SiteIcon } from '../../models/site-icons/site-icon.model';

@Component({
    selector: 'app-list-icons',
    templateUrl: './list-icons.dialog.html',
    styleUrls: ['./list-icons.dialog.scss'],
    standalone: false
})
export class ListIconsDialog implements OnInit {
    // Properties.
    private siteIconsList: SiteIcon[] = [];
    //private selectedIcon: SiteIcon = null;
    private selectedIconIds: number[] = [];

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ListIconsDialog>,
        @Inject(MAT_DIALOG_DATA) public initObjectNotPresentlyUsed: any,
        private siteIconService: SiteIconService,
        private currentSiteService: CurrentSiteService,
        private clipboard: Clipboard) { }

    // Life cycle methods.
    public ngOnInit(): void {
        // Query site icons.
        this.siteIconService.listSiteIcons(this.currentSiteService.Site.id).then(response => {
            this.siteIconsList = response;
        });
    }

    // Methods called by my HTML code.
    public get SiteIcons(): SiteIcon[] {
        return this.siteIconsList;
    }

    public get SelectedIconIds(): number[] {
        return this.selectedIconIds;
    }
    public set SelectedIconIds(value: number[]) {
        this.selectedIconIds = value;
    }

    public get CopyImagesButtonTitle(): string {
        let title: string = this.selectedIconIds.length == 1 ? 'Copy 1 Image Tag' : `Copy ${this.selectedIconIds.length} Image Tags`;
        return title;
    }

    public ImageSource(siteIcon: SiteIcon): string {
        // https://hs1309w1.sandbox.max.gov/api/siteicon/get/1
        let imageSource: string = siteIcon.iconUrl;
        return imageSource;
    }

    // Handle control events.
    public copyIconUrlClicked(): void {
        let selectedIcons = this.siteIconsList.filter(si => this.selectedIconIds.includes(si.id));
        let imageTags: string = '';
        for (let index: number = 0; index < selectedIcons.length; index++) {
            if (index > 0)
                imageTags += "\r\n";

            imageTags += selectedIcons[index].iconImgTag;
        }
        this.clipboard.copy(imageTags);
    }

    public cancelClicked(): void {
        this.dialogRef.close(null);
    }
}
